export default __webpack_public_path__ + "static/media/student-black.b887841d.svg";